import styled from "styled-components";
import theme from "../../theme/theme";

export const UploadFileContainer = styled.div`
  color: ${theme.color.black};
  width: 100%;
  max-width: 500;
  display: flex;
  align-items: center;
  text-align: left;
  font-family: "Inter", sans-serif;
  justify-content: center;
`;

export const DropZone = styled.div`
  text-align: center;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 16px;
  width: auto;
  height: 150px;

  @media (max-width: 768px) {
    height: auto;
  }
`;

export const BtnContainer = styled.div`
  align-items: center;
  text-align: center;
  margin-bottom: 10px;
`;

export const Border = styled.div`
  border: 1.5px dashed #000000;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  padding: 5px;
  background-color: #FAF9F9;
  height: 100%;
`;